import store from '../store'
import moment from 'moment'
const urlParser = document.createElement('a')
const countries = {
  de: require('./countriesDE.json'),
  en: require('./countriesEN.json'),
  es: require('./countriesES.json')
}

export function domain (url) {
  urlParser.href = url
  return urlParser.hostname
}
export function toLower (string) {
  return string.toLowerCase()
}
export function orderDate (date, mode = false) {
  let d = moment(date, 'DD.MM.YYYY HH:mm:ss')
  return mode ? d.format('HH:mm:ss') : d.format('DD.MM.YYYY')
}
export function orderDateReverse (date, mode = false) {
  let d = moment(date, 'YYYY.MM.DD HH:mm:ss')
  return mode ? d.format('HH:mm:ss') : d.format('DD.MM.YYYY')
}
export function orderTitle (title) {
  return title.length > 55 ? title.substr(0, 55) + ' ...' : title
}
export function currency (number = '0', symbol = '€') {

  let isPositive = number >= 0
  if (!isPositive) {
    number *= -1
  }

  number = parseFloat(number)
  number = number.toFixed(2).replace('.', ',')

  let con = number.split(',')
  let separated = reverse(con[0]).match(/.{1,3}/g)
  let i = 0
  let final = ''
  while (i < separated.length) {
    if (i === 0) {
      final = reverse(separated[i])
    } else {
      final = final.concat('.', reverse(separated[i]))
    }i++
  }
  let b = ''
  final.split('.').reverse().forEach(x => {
    b = b + x.split().reverse()
  })
  return symbol + ' ' + (!isPositive ? '-' : '') + final.split('.').reverse().join('.').concat(',', con[1] === undefined ? '00' : con[1])
}

export function percentage (number = '0') {
  number = parseFloat(number)
  return number.toFixed(2).replace('.', ',') + ' %'
}

function reverse (s) {
  return s.split('').reverse().join('')
}

export function count (arr) {
  return arr.length
}
export function dateFormat (date) {
  let d = new Date(date)
  let newDate = ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear()
  newDate += ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':'
  newDate += ('0' + d.getSeconds()).slice(-2)
  return newDate
}
export function dateFormat2 (date) {
  let d = new Date(date)
  let newDate = ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear()
  return date
}
export function toUpper (word) {
  return word.toUpperCase()
}
export function translate (word, translateNotNumbers = false) {
  if (translateNotNumbers && typeof word === 'number')  {
    return word
  }
  let json = require('./translation.json')
  let trans = json[word]
  return typeof trans === 'undefined' ? 'undefined' : trans[store.getters.language]
}
export function fieldNotInUse (number = '0') {
  return ('---')
}
export function country (word) {
  let countries = {
    'BD': 'Bangladesh',
    'BE': 'Belgium',
    'BF': 'Burkina Faso',
    'BG': 'Bulgaria',
    'BA': 'Bosnia and Herzegovina',
    'BB': 'Barbados',
    'WF': 'Wallis and Futuna',
    'BL': 'Saint Barthelemy',
    'BM': 'Bermuda',
    'BN': 'Brunei',
    'BO': 'Bolivia',
    'BH': 'Bahrain',
    'BI': 'Burundi',
    'BJ': 'Benin',
    'BT': 'Bhutan',
    'JM': 'Jamaica',
    'BV': 'Bouvet Island',
    'BW': 'Botswana',
    'WS': 'Samoa',
    'BQ': 'Bonaire, Saint Eustatius and Saba ',
    'BR': 'Brazil',
    'BS': 'Bahamas',
    'JE': 'Jersey',
    'BY': 'Belarus',
    'BZ': 'Belize',
    'RU': 'Russia',
    'RW': 'Rwanda',
    'RS': 'Serbia',
    'TL': 'East Timor',
    'RE': 'Reunion',
    'TM': 'Turkmenistan',
    'TJ': 'Tajikistan',
    'RO': 'Romania',
    'TK': 'Tokelau',
    'GW': 'Guinea-Bissau',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GS': 'South Georgia and the South Sandwich Islands',
    'GR': 'Greece',
    'GQ': 'Equatorial Guinea',
    'GP': 'Guadeloupe',
    'JP': 'Japan',
    'GY': 'Guyana',
    'GG': 'Guernsey',
    'GF': 'French Guiana',
    'GE': 'Georgia',
    'GD': 'Grenada',
    'GB': 'United Kingdom',
    'GA': 'Gabon',
    'SV': 'El Salvador',
    'GN': 'Guinea',
    'GM': 'Gambia',
    'GL': 'Greenland',
    'GI': 'Gibraltar',
    'GH': 'Ghana',
    'OM': 'Oman',
    'TN': 'Tunisia',
    'JO': 'Jordan',
    'HR': 'Croatia',
    'HT': 'Haiti',
    'HU': 'Hungary',
    'HK': 'Hong Kong',
    'HN': 'Honduras',
    'HM': 'Heard Island and McDonald Islands',
    'VE': 'Venezuela',
    'PR': 'Puerto Rico',
    'PS': 'Palestinian Territory',
    'PW': 'Palau',
    'PT': 'Portugal',
    'SJ': 'Svalbard and Jan Mayen',
    'PY': 'Paraguay',
    'IQ': 'Iraq',
    'PA': 'Panama',
    'PF': 'French Polynesia',
    'PG': 'Papua New Guinea',
    'PE': 'Peru',
    'PK': 'Pakistan',
    'PH': 'Philippines',
    'PN': 'Pitcairn',
    'PL': 'Poland',
    'PM': 'Saint Pierre and Miquelon',
    'ZM': 'Zambia',
    'EH': 'Western Sahara',
    'EE': 'Estonia',
    'EG': 'Egypt',
    'ZA': 'South Africa',
    'EC': 'Ecuador',
    'IT': 'Italy',
    'VN': 'Vietnam',
    'SB': 'Solomon Islands',
    'ET': 'Ethiopia',
    'SO': 'Somalia',
    'ZW': 'Zimbabwe',
    'SA': 'Saudi Arabia',
    'ES': 'Spain',
    'ER': 'Eritrea',
    'ME': 'Montenegro',
    'MD': 'Moldova',
    'MG': 'Madagascar',
    'MF': 'Saint Martin',
    'MA': 'Morocco',
    'MC': 'Monaco',
    'UZ': 'Uzbekistan',
    'MM': 'Myanmar',
    'ML': 'Mali',
    'MO': 'Macao',
    'MN': 'Mongolia',
    'MH': 'Marshall Islands',
    'MK': 'Macedonia',
    'MU': 'Mauritius',
    'MT': 'Malta',
    'MW': 'Malawi',
    'MV': 'Maldives',
    'MQ': 'Martinique',
    'MP': 'Northern Mariana Islands',
    'MS': 'Montserrat',
    'MR': 'Mauritania',
    'IM': 'Isle of Man',
    'UG': 'Uganda',
    'TZ': 'Tanzania',
    'MY': 'Malaysia',
    'MX': 'Mexico',
    'IL': 'Israel',
    'FR': 'France',
    'IO': 'British Indian Ocean Territory',
    'SH': 'Saint Helena',
    'FI': 'Finland',
    'FJ': 'Fiji',
    'FK': 'Falkland Islands',
    'FM': 'Micronesia',
    'FO': 'Faroe Islands',
    'NI': 'Nicaragua',
    'NL': 'Netherlands',
    'NO': 'Norway',
    'NA': 'Namibia',
    'VU': 'Vanuatu',
    'NC': 'New Caledonia',
    'NE': 'Niger',
    'NF': 'Norfolk Island',
    'NG': 'Nigeria',
    'NZ': 'New Zealand',
    'NP': 'Nepal',
    'NR': 'Nauru',
    'NU': 'Niue',
    'CK': 'Cook Islands',
    'XK': 'Kosovo',
    'CI': 'Ivory Coast',
    'CH': 'Switzerland',
    'CO': 'Colombia',
    'CN': 'China',
    'CM': 'Cameroon',
    'CL': 'Chile',
    'CC': 'Cocos Islands',
    'CA': 'Canada',
    'CG': 'Republic of the Congo',
    'CF': 'Central African Republic',
    'CD': 'Democratic Republic of the Congo',
    'CZ': 'Czech Republic',
    'CY': 'Cyprus',
    'CX': 'Christmas Island',
    'CR': 'Costa Rica',
    'CW': 'Curacao',
    'CV': 'Cape Verde',
    'CU': 'Cuba',
    'SZ': 'Swaziland',
    'SY': 'Syria',
    'SX': 'Sint Maarten',
    'KG': 'Kyrgyzstan',
    'KE': 'Kenya',
    'SS': 'South Sudan',
    'SR': 'Suriname',
    'KI': 'Kiribati',
    'KH': 'Cambodia',
    'KN': 'Saint Kitts and Nevis',
    'KM': 'Comoros',
    'ST': 'Sao Tome and Principe',
    'SK': 'Slovakia',
    'KR': 'South Korea',
    'SI': 'Slovenia',
    'KP': 'North Korea',
    'KW': 'Kuwait',
    'SN': 'Senegal',
    'SM': 'San Marino',
    'SL': 'Sierra Leone',
    'SC': 'Seychelles',
    'KZ': 'Kazakhstan',
    'KY': 'Cayman Islands',
    'SG': 'Singapore',
    'SE': 'Sweden',
    'SD': 'Sudan',
    'DO': 'Dominican Republic',
    'DM': 'Dominica',
    'DJ': 'Djibouti',
    'DK': 'Denmark',
    'VG': 'British Virgin Islands',
    'DE': 'Germany',
    'YE': 'Yemen',
    'DZ': 'Algeria',
    'US': 'United States',
    'UY': 'Uruguay',
    'YT': 'Mayotte',
    'UM': 'United States Minor Outlying Islands',
    'LB': 'Lebanon',
    'LC': 'Saint Lucia',
    'LA': 'Laos',
    'TV': 'Tuvalu',
    'TW': 'Taiwan',
    'TT': 'Trinidad and Tobago',
    'TR': 'Turkey',
    'LK': 'Sri Lanka',
    'LI': 'Liechtenstein',
    'LV': 'Latvia',
    'TO': 'Tonga',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'LR': 'Liberia',
    'LS': 'Lesotho',
    'TH': 'Thailand',
    'TF': 'French Southern Territories',
    'TG': 'Togo',
    'TD': 'Chad',
    'TC': 'Turks and Caicos Islands',
    'LY': 'Libya',
    'VA': 'Vatican',
    'VC': 'Saint Vincent and the Grenadines',
    'AE': 'United Arab Emirates',
    'AD': 'Andorra',
    'AG': 'Antigua and Barbuda',
    'AF': 'Afghanistan',
    'AI': 'Anguilla',
    'VI': 'U.S. Virgin Islands',
    'IS': 'Iceland',
    'IR': 'Iran',
    'AM': 'Armenia',
    'AL': 'Albania',
    'AO': 'Angola',
    'AQ': 'Antarctica',
    'AS': 'American Samoa',
    'AR': 'Argentina',
    'AU': 'Australia',
    'AT': 'Austria',
    'AW': 'Aruba',
    'IN': 'India',
    'AX': 'Aland Islands',
    'AZ': 'Azerbaijan',
    'IE': 'Ireland',
    'ID': 'Indonesia',
    'UA': 'Ukraine',
    'QA': 'Qatar',
    'MZ': 'Mozambique'
  }
  return countries[word]
}
export function newCountry (word, language) {
  if (countries[language]) {
    if (word === 'all') {
      return 'All'
    } else {
      if (word === 'uk') {
        return 'United Kingdom'
      } else {
        if (word === 'deutschland') {
          return 'Germany'
        } else {
          let filter = countries[language].filter(x => {
            return x.alpha2 === word
          }).pop();
          if (!filter) {
            return word;
          }
          return filter.name
        }
      }
    }
  } else {
    return word
  }
}
export function prettyDate (date) {
  let a = new Date(date)
  return a.toDateString()
}
export function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

export function capitalize (str) {
  if (str === 'ebay') {
    return 'eBay'
  } else if (str === 'schuhede') {
    return 'schuhe.de'
  }
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}



// WEBPACK FOOTER //
// ./src/filters/index.js